import { render } from "./FacultyCountByProgramChart.vue?vue&type=template&id=78dc1186"
import script from "./FacultyCountByProgramChart.vue?vue&type=script&lang=js"
export * from "./FacultyCountByProgramChart.vue?vue&type=script&lang=js"
script.render = render

export default script